import { lazyLoadView } from '@utils/LazyLoad'

// Rotas do módulo workflow-engine (T053) — TODAS autenticadas (profissional/gestor).
//
// 1) Workflows + Registry/builder — nestados sob o shell nav-bar (regra mandatória
//    do DS: toda view de módulo usa NavBarNavigation). O shell renderiza a nav-bar
//    + <router-view> das abas (Workflows; Triggers). O detalhe do workflow é filho
//    do shell (alcançado pela lista) e mantém a nav-bar.
//
// 2) Preenchimento do form — `/workflow-engine/form/:token` (standalone, fora
//    do shell de abas, mas dentro do layout autenticado). Quem preenche é um
//    profissional/gestor do escritório; o backend valida sessão + office-match
//    do token (gate P1). Recebe SÓ o token (US-8): NUNCA office/workflow.

export default [
  {
    path: '/workflow-engine',
    component: () =>
      lazyLoadView(
        import(
          '@modules/workflow-engine/views/nav-bar/workflow-engine-nav-bar.vue'
        )
      ),
    redirect: { name: 'workflow-engine.workflow-list' },
    children: [
      {
        path: 'workflows',
        name: 'workflow-engine.workflow-list',
        meta: {
          permission: ['profissional', 'gestor'],
        },
        component: () =>
          lazyLoadView(
            import('@modules/workflow-engine/views/workflow-list.vue')
          ),
      },
      {
        path: 'workflows/:id',
        name: 'workflow-engine.workflow-detail',
        props: true,
        meta: {
          permission: ['profissional', 'gestor'],
        },
        component: () =>
          lazyLoadView(
            import('@modules/workflow-engine/views/workflow-detail.vue')
          ),
      },
      {
        path: 'triggers',
        name: 'workflow-engine.triggers',
        meta: {
          permission: ['profissional', 'gestor'],
        },
        component: () =>
          lazyLoadView(
            import('@modules/workflow-engine/views/trigger-list.vue')
          ),
      },
      {
        path: 'triggers/:idTrigger',
        name: 'workflow-engine.trigger-form-builder',
        props: true,
        meta: {
          permission: ['profissional', 'gestor'],
        },
        component: () =>
          lazyLoadView(
            import(
              '@modules/workflow-engine/views/trigger-form-builder.vue'
            )
          ),
      },
    ],
  },
  {
    // Página de preenchimento do formulário (profissional/gestor logado).
    // SÓ o token na URL (US-8); o backend resolve o office e valida o match.
    path: '/workflow-engine/form/:token',
    name: 'workflow-engine.form-fill',
    props: true,
    meta: {
      permission: ['profissional', 'gestor'],
    },
    component: () =>
      lazyLoadView(
        import('@modules/workflow-engine/views/form-fill-view.vue')
      ),
  },
]
